const state = {
  showNavbar: "initial",
  statusFilter: null,
  fileTypeFilter: null,
  useTypeFilter: null,
  memberFilter: null,
  showIneligible: false,
}

const mutations = {
  setStatusFilter (state, value) {
    state.statusFilter = value
  },
  setFileTypeFilter (state, value) {
    state.fileTypeFilter = value
  },
  setMemberFilter (state, value) {
    state.memberFilter = value
  },
  setUseTypeFilter (state, value) {
    state.useTypeFilter = value
  },
  setShowIneligible (state, value) {
    state.showIneligible = value
  },
  toggleNavbar (state, value) {
    if (value === "close") {
      state.showNavbar = false
      return
    }
    if (state.showNavbar === "initial") {
      state.showNavbar = true
      return
    }
    state.showNavbar = !state.showNavbar
  },
}

const actions = {
  clearFilters ({ commit }) {
    commit("setUseTypeFilter", null)
    commit("setStatusFilter", null)
    commit("setFileTypeFilter", null)
    commit("setMemberFilter", null)
    commit("setShowIneligible", false)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
